import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'

const legFields: FieldInterface[] = [
  {
    key: 'date',
    originKey: 'date',
    type: FIELD_TYPES.date,
  },
  {
    key: 'attributionType',
    originKey: 'attribution_type',
    type: FIELD_TYPES.string,
  },
  {
    key: 'attributionTypeLabel',
    originKey: 'attribution_type_label',
    type: FIELD_TYPES.string,
  },
  {
    key: 'valueAtDate',
    originKey: 'value_at_date',
    type: FIELD_TYPES.number,
  },
  {
    key: 'valueAtDeathDate',
    originKey: 'value_at_death_date',
    type: FIELD_TYPES.number,
  },
]

const legRelations: RelationInterface[] = [
  {
    key: '_attributor',
    originKey: 'attributor',
    objectType: OBJECT_TYPES.person,
  },
  {
    key: '_legacy_receivers',
    originKey: 'legacy_receivers',
    objectType: OBJECT_TYPES.legReceiver,
    isMultiple: true,
  },
  {
    key: '_legacy_goods',
    originKey: 'legacy_goods',
    objectType: OBJECT_TYPES.legGood,
    isMultiple: true,
  },
]

export { legFields, legRelations }
